import { useContext } from 'react';

import { ListContext } from '@contexts/ListContext';

const useDepartments = () => {
    const { cachedList } = useContext(ListContext);

    const departments = [];

    if (!cachedList?.accountingGroups?.items) {
        return departments;
    }

    for (const accGroup of cachedList.accountingGroups.items) {
        for (const nwAg of accGroup.NetworkAgencies) {
            for (const department of nwAg.Departments) {
                departments.push({
                    id: department.ID,
                    name: department.Name,
                    networkagencyid: nwAg.ID,
                    accountinggroupid: accGroup.ID,
                });
            }
        }
    }

    return departments;
};

export default useDepartments;
